import { render } from "./swiperComponent.vue?vue&type=template&id=c54c0bd6&scoped=true&ts=true"
import script from "./swiperComponent.vue?vue&type=script&lang=ts"
export * from "./swiperComponent.vue?vue&type=script&lang=ts"

import "./swiperComponent.vue?vue&type=style&index=0&id=c54c0bd6&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54c0bd6"]])

export default __exports__